import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"
import PropTypes from "prop-types"
import React from "react"
import Logo from "../assets/logo.svg"

const Header = ({ siteTitle }) => (
  <header
    style={{
      textAlign: "center",
    }}
  >
    <Logo
      style={{
        maxWidth: "300px",
        display: "block",
        margin: "0 auto",
      }}
    />
    <div className="links">
      <a href="https://www.instagram.com/dabcatofficial/">
        <FontAwesomeIcon icon={faInstagram} />
        dabcatofficial
      </a>
      <a href="mailto:dabcatofficial@gmail.com">
        <FontAwesomeIcon icon={faEnvelope} /> dabcatofficial@gmail.com
      </a>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
